import { render, staticRenderFns } from "./SocialsIcon.vue?vue&type=template&id=7f326299&scoped=true"
import script from "./SocialsIcon.vue?vue&type=script&lang=js"
export * from "./SocialsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f326299",
  null
  
)

export default component.exports